import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import { exportToCSV } from "../../../../utils/exportCsv";
import toast from "react-hot-toast";

const CartonChildList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const carton = location.state;
    const productList = carton?.product_list || [];

    const handleExportCSV = () => {
        if (!productList || productList.length === 0) {
            toast.error("No product data available to export");
            return;
        }
        const exportColumns = [
            { name: "Product Code", selector: (row) => row.product_code || "-" },
            { name: "Qty", selector: (row) => row.qty ?? "-" },
            { name: "Original Qty", selector: (row) => row.original_qty ?? "-" },
            { name: "Price", selector: (row) => row.price ?? "-" },
            { name: "Line Created At", selector: (row) => row.line_created_at ? new Date(row.line_created_at).toLocaleString() : "-" },
            { name: "Line Updated At", selector: (row) => row.line_updated_at ? new Date(row.line_updated_at).toLocaleString() : "-" },
        ];
        exportToCSV(productList, exportColumns, `carton_${carton?.carton_number || 'child'}_products.csv`);
        toast.success("CSV Downloaded Successfully!");
    };

    if (!carton) {
        return (
            <div className="flex w-full bg-gray-200 h-full justify-center items-center">
                <div className="bg-white shadow rounded-lg p-8 text-center">
                    <h2 className="text-xl font-bold mb-4">No carton data found</h2>
                    <p className="mb-4">Please go back and select a carton from the list.</p>
                    <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
        );
    }

    const columns = [
        { name: "SNo", cell: (row, idx) => idx + 1, sortable: true },
        { name: "Product Code", cell: (row) => row.product_code, sortable: true },
        { name: "Qty", cell: (row) => row.qty, sortable: true },
        { name: "Original Qty", cell: (row) => row.original_qty, sortable: true },
        { name: "Price", cell: (row) => row.price, sortable: true },
        { name: "Line Created At", cell: (row) => new Date(row.line_created_at).toLocaleString(), sortable: true },
        { name: "Line Updated At", cell: (row) => new Date(row.line_updated_at).toLocaleString(), sortable: true },
    ];

    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full ">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    Carton Child Product List
                    <LinksComponent />
                </div>
                <div className="p-3">
                    <div className="bg-white shadow rounded-lg">
                        <div className="border-b border-gray-300 bg-gray-50 rounded-t-lg p-3">
                            <div className="flex space-x-2 justify-between">
                                <div>
                                    <span className="font-semibold">Carton Number:</span> {carton?.carton_number}
                                </div>
                                <div>
                                    <span className="font-semibold">Order No:</span> {carton?.order_no}
                                </div>
                                <div>
                                    <span className="font-semibold">Customer Name:</span> {carton?.customer_name}
                                </div>
                                <div className="flex gap-2">
                                    <button className="btn btn-outline-primary" onClick={handleExportCSV}>Export CSV</button>
                                    <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>Back</button>
                                </div>
                            </div>
                        </div>
                        <DataTableComponent
                            keyField={(row) => row.line_id}
                            columns={columns}
                            data={productList}
                            loading={false}
                            totalRows={productList.length}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartonChildList;
